const ComboIcon = ({
  size = 20,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='none'
      >
        <g clipPath='url(#clip0_9381_164268)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.5 1.66667H1.66667L1.66667 12.5H12.5V1.66667ZM1.66667 0C0.746192 0 0 0.746192 0 1.66667V12.5C0 13.4205 0.746192 14.1667 1.66667 14.1667H12.5C13.4205 14.1667 14.1667 13.4205 14.1667 12.5V1.66667C14.1667 0.746192 13.4205 0 12.5 0H1.66667Z'
            fill='#AEAEB2'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15.8333 2.5C16.2936 2.5 16.6667 2.8731 16.6667 3.33333V13.3333C16.6667 15.1743 15.1743 16.6667 13.3333 16.6667H3.33333C2.8731 16.6667 2.5 16.2936 2.5 15.8333C2.5 15.3731 2.8731 15 3.33333 15H13.3333C14.2538 15 15 14.2538 15 13.3333V3.33333C15 2.8731 15.3731 2.5 15.8333 2.5Z'
            fill='#AEAEB2'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M18.3333 5C18.7936 5 19.1667 5.3731 19.1667 5.83333V14.1667C19.1667 16.9281 16.9281 19.1667 14.1667 19.1667H5.83333C5.3731 19.1667 5 18.7936 5 18.3333C5 17.8731 5.3731 17.5 5.83333 17.5H14.1667C16.0076 17.5 17.5 16.0076 17.5 14.1667V5.83333C17.5 5.3731 17.8731 5 18.3333 5Z'
            fill='#AEAEB2'
          />
        </g>
        <defs>
          <clipPath id='clip0_9381_164268'>
            <rect width='20' height='20' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default ComboIcon;
